/* eslint-disable import/order */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthenticatedRoute from './components/general/AuthenticatedRoute';
import * as Urls from './constants/Urls';
import NoMatch from './components/general/NoMatch';
import Login from './containers/Login';
import Logout from './containers/Logout';
import MainDashboard from './containers/Dashboard';
import DocumentRepository from './containers/DocumentRepository';
import DocumentViewer from './containers/DocumentViewer';
import DocumentCollaboration from './containers/DocumentCollaboration';
import DocumentCompare from './containers/DocumentCompare';
import Help from './containers/Help';
import FindPage from './containers/FindPage';

import MasterSetupPage from './containers/MasterSetupPage';
import MonitoringQueueSetupPage from './containers/QueueSetupPage';
import SearchPage from './containers/SearchPage';
import CalendarPage from './containers/CalendarPage';
import FormEditorPage from './containers/FormEditorPage';
import ClosePage from './containers/ClosePage';
import UpgradeModulesPage from './containers/UpgradeModules';
import CacheListPage from './containers/CacheListPage';
import FormsListPage from './containers/FormsList';
import EntitiesListPage from './containers/EntitiesList';
import CertificationPage from './containers/CertificationPage';
import EntityEditorPage from './containers/EntityEditorPage';
import WorkflowStepPage from './containers/WorkflowStepPage';
import SavedSearchEditorPage from './containers/SavedSearchEditorPage';
import EntityDisplay from './containers/EntityDisplay';
import RuntimeRedirectRoute from './components/general/RuntimeRedirectRoute';

import PowerBIReportPage from './containers/PowerBI/PowerBIReportPage';
import PowerBIReportsPage from './containers/PowerBI/PowerBIReportsPage';
import ReportModelPage from './containers/ReportModelPage';
import ProductHierarchy from './containers/ProductHierarchy';
import ReportDesignerPage from './containers/ReportDesignerPage';
import SmartInsightDashboard from './containers/SmartInsightPage';
import SmartInsightReportsListPage from './containers/SmartInsightReportsListPage';
import AppMigrationPage from './containers/AppMigrationPage';
import ConfigureDataSources from './containers/ConfigureDataSources';
import RepositoryConfiguration from './containers/RepositoryConfiguration';
import RepositoryListPage from './containers/RepositoryListPage';

const Routes = () => (
  <Switch>
    <AuthenticatedRoute exact path={Urls.HOME} component={MainDashboard} />
    <AuthenticatedRoute path={Urls.MAIN_DASHBOARD} component={MainDashboard} />
    <AuthenticatedRoute path={Urls.ENTITY_DISPLAY} component={EntityDisplay} />
    <AuthenticatedRoute path={Urls.WORKFLOW_STEP} component={WorkflowStepPage} />
    <AuthenticatedRoute path={Urls.HELP} component={Help} />

    <AuthenticatedRoute path={Urls.FIND_PAGE} component={FindPage} />
    <AuthenticatedRoute path={Urls.MASTER_SETUP_PAGE} component={MasterSetupPage} />
    <AuthenticatedRoute path={Urls.WORKFLOW_MASTER_SETUP_PAGE} component={MasterSetupPage} />
    <AuthenticatedRoute path={Urls.QUEUE_SETUP_PAGE} component={MonitoringQueueSetupPage} />
    <AuthenticatedRoute
      path={Urls.WORKFLOW_QUEUE_SETUP_PAGE}
      component={MonitoringQueueSetupPage}
    />

    <AuthenticatedRoute path={Urls.ENHANCED_SEARCH_PAGE} component={SearchPage} />

    <AuthenticatedRoute path={Urls.DOCUMENT_REPOSITORY} component={DocumentRepository} />
    <AuthenticatedRoute path={Urls.PRODUCT_HIERARCHY} component={ProductHierarchy} />
    <AuthenticatedRoute path={Urls.DOCUMENT_VIEWER} component={DocumentViewer} />
    <AuthenticatedRoute path={Urls.DOCUMENT_COLLABORATION} component={DocumentCollaboration} />
    <AuthenticatedRoute path={Urls.DOCUMENT_COMPARE} component={DocumentCompare} />
    <AuthenticatedRoute path={Urls.CERTIFICATION_PAGE} component={CertificationPage} />
    <AuthenticatedRoute path={Urls.CALENDAR_PAGE} component={CalendarPage} />
    <AuthenticatedRoute path={Urls.TRAININGS} component={WorkflowStepPage} />

    <AuthenticatedRoute path={Urls.FORM_EDITOR} component={FormEditorPage} />
    <AuthenticatedRoute path={Urls.BULK_EDIT_PAGE} component={WorkflowStepPage} />

    <AuthenticatedRoute path={Urls.UPGRADE_MODULES_PAGE} component={UpgradeModulesPage} />
    <AuthenticatedRoute path={Urls.CACHE_LIST} component={CacheListPage} />
    <AuthenticatedRoute path={Urls.REPOSITORY_CONFIGURATION} component={RepositoryConfiguration} />
    <AuthenticatedRoute path={Urls.REPOSITORY_LIST} component={RepositoryListPage} />
    <AuthenticatedRoute path={Urls.FORMS_LIST} component={FormsListPage} />
    <AuthenticatedRoute path={Urls.ENTITIES_LIST} component={EntitiesListPage} />
    <AuthenticatedRoute path={Urls.ENTITY_EDITOR} component={EntityEditorPage} />
    <AuthenticatedRoute path={Urls.ENTITY_DETAILS} component={EntityEditorPage} />

    <AuthenticatedRoute path={Urls.SMART_INSIGHT} component={SmartInsightDashboard} />
    <AuthenticatedRoute path={Urls.REPORT_MODEL_DESIGNER} component={ReportModelPage} />
    <AuthenticatedRoute path={Urls.REPORT_DESIGNER} component={ReportDesignerPage} />
    <AuthenticatedRoute path={Urls.SAVED_SEARCH_EDITOR} component={SavedSearchEditorPage} />
    <AuthenticatedRoute
      path={Urls.SMART_INSIGHT_REPORTS_LIST}
      component={SmartInsightReportsListPage}
    />

    <AuthenticatedRoute path={Urls.POWERBI_REPORT_PAGE} component={PowerBIReportPage} />
    <AuthenticatedRoute path={Urls.POWERBI_EDITOR_PAGE} component={PowerBIReportPage} />
    <AuthenticatedRoute path={Urls.POWERBI_REPORTS_PAGE} component={PowerBIReportsPage} />

    <AuthenticatedRoute path={Urls.APP_MIGRATION_PAGE} component={AppMigrationPage} />
    <AuthenticatedRoute path={Urls.CONFIGURE_DATA_SOURCE} component={ConfigureDataSources} />

    <RuntimeRedirectRoute path={Urls.NEW_WORKFLOW_STEP} />
    <RuntimeRedirectRoute path={Urls.NEW_ENTITY_DISPLAY} />
    <RuntimeRedirectRoute path={Urls.NEW_MASTER_SETUP_PAGE} />

    <Route path={Urls.LOGIN} component={Login} />
    <Route path={Urls.LOGOUT} component={Logout} />
    <Route path={Urls.PAGE_CLOSE} component={ClosePage} />
    <Route component={NoMatch} />
  </Switch>
);

export default Routes;
